import React from 'react';
import ZuruuTailan from './zuruuTailan';

const PageList = () => <ZuruuTailan />;

export default PageList;
